import * as React from 'react';
import { Context, UserContext } from './Context';

export const useUserContext = () => React.useContext(Context);

export interface WithUserContextProps {
	userContext: UserContext;
}
